import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('TextContainer')(css({
    height: '100%',
    marginTop: ['30px', '0'],
    textAlign: 'center',
}));
themeStyles.addBaseStyles('GraphicContainer')(css({
    minHeight: '275px',
}));
themeStyles.addBaseStyles('LongNameTextObject')(({ x }) => css({
    textAlign: x > 0 ? 'left' : 'right',
    fontSize: ['14px', '12px'],
    lineHeight: ['16px', '18px'],
    fontFamily: 'default',
}));
themeStyles.addBaseStyles('DonutContainer')(({ theme }) => css({
    width: '90%',
    margin: '0px auto',
    '.recharts-wrapper': {
        display: 'flex',
        justifyContent: 'center',
    },
    '.recharts-surface': {
        overflow: 'inherit',
    },
    '.recharts-responsive-container': {
        height: '295px',
        '.recharts-curve.recharts-pie-label-line': {
            stroke: theme.primaryBlack,
        },
        '.recharts-wrapper': {
            maxHeight: ['130px', '285px'],
            display: 'flex',
            alignItems: 'center',
        },
    },
    text: {
        fontSize: ['14px', '12px'],
        lineHeight: ['16px', '18px'],
        fontFamily: 'default',
    },
    '.value': {
        fontSize: '16px',
        fontFamily: 'bold',
    },
    '@media (max-width: 767px)': {
        padding: '0px',
        margin: '0 auto',
        width: '75%',
    }
}));
export default themeStyles;
